module.exports = __webpack_public_path__ + "static/pond1-cfdceccdaf19e4ab3f8c7331a43a6e6d.jpg";